var _ = require('underscore/underscore');
var BasePopup = require('front/components/BasePopup/BasePopup');

var template = require('./RatesBulletinPopup.jinja');
require('./RatesBulletinPopup.less');

module.exports = BasePopup.extend({

    template: template,

    events: _.extend({

    }, BasePopup.prototype.baseEvents),


    apiUrl: function () {
        return Urls['front:api:rates_bulletin-popup']();
    },


    initialize: function (options) {
        this.options = options || {};

        BasePopup.prototype.initialize.call(this, options);
    },


    viewsRegistration: function () {
        BasePopup.prototype.viewsRegistration.call(this);

        this.$('iframe').each(function (ind, item) {
            $(this).ready(function () {
                var $iframeWrapper = $(item).closest('.RatesBulletinPopup-bulletin-iframe');
                $iframeWrapper.removeClass('RatesBulletinPopup-bulletin-iframe--loading');
                console.log('load');
            });
        });
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/pages/RatesBulletinPopup/RatesBulletinPopup.js
// module id = 292
// module chunks = 0